var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget",class:_vm.theme},[_c('i',{staticClass:"icon icon-share"})])
}
var staticRenderFns = []

export { render, staticRenderFns }